export enum ServiceOrderStatus {
  ReadyForPayment = 'Ready for Payment',
  Failed = 'Failed',
  Expired = 'Expired',
  Processing = 'Processing',
  Completed = 'Completed',
}
